// src/core/AudioPlayer.ts
import { Howl } from 'howler';
import config from './config';
import Logger from './Logger';
class AudioPlayer {
    constructor() {
        this.currentSound = null;
        this.playAiReplyFromStream = (audioStream, callback) => {
            Logger.log('F: playAiReplyFromStream');
            const audioContext = new AudioContext();
            const reader = audioStream.getReader();
            let chunks = [];
            reader
                .read()
                .then(function process({ done, value, }) {
                if (done) {
                    // Concatenate all chunks into a single ArrayBuffer
                    const length = chunks.reduce((acc, val) => acc + val.length, 0);
                    const concatenated = new Uint8Array(length);
                    let offset = 0;
                    for (let chunk of chunks) {
                        concatenated.set(chunk, offset);
                        offset += chunk.length;
                    }
                    // Decode and play the audio
                    audioContext
                        .decodeAudioData(concatenated.buffer)
                        .then((buffer) => {
                        const source = audioContext.createBufferSource();
                        source.buffer = buffer;
                        source.connect(audioContext.destination);
                        source.start();
                        if (callback)
                            callback();
                    })
                        .catch((error) => {
                        Logger.error(`Failed to play sound from stream`, error);
                    });
                    return Promise.resolve();
                }
                chunks.push(value);
                return reader.read().then(process);
            })
                .catch((error) => {
                Logger.error(`Failed to play sound from stream`, error);
            });
        };
        this.playAiReplyFromUrl = (audioFileUrl, callback) => {
            Logger.log('F: playAiReplyFromUrl');
            // Play AI reply at 100% volume (1.0 = 100%)
            this.currentSound = this.playSound(audioFileUrl, callback, 1.0);
        };
        this.playStartTone = () => {
            this.startSound.play();
        };
        this.playEndTone = () => {
            this.endSound.play();
        };
        this.setVolume = (volume) => {
            if (this.currentSound) {
                this.currentSound.volume(volume);
            }
        };
        this.stopCurrentSound = () => {
            if (this.currentSound) {
                this.currentSound.stop();
                this.currentSound = null;
            }
        };
        this.initializeSound = (soundFileUrl, volume = 1.0) => {
            return new Howl({
                src: [soundFileUrl],
                volume: volume,
                onloaderror: (id, error) => Logger.error(`Failed to load sound: ${soundFileUrl}`, error),
                onplayerror: (id, error) => Logger.error(`Failed to play sound: ${soundFileUrl}`, error),
            });
        };
        this.playSound = (soundFileUrl, callback, volume) => {
            Logger.log('F: playSound');
            const sound = new Howl({
                src: [soundFileUrl],
                volume: volume,
                onend: () => {
                    if (callback)
                        callback();
                },
                onloaderror: (id, error) => Logger.error(`Failed to load sound: ${soundFileUrl}`, error),
                onplayerror: (id, error) => Logger.error(`Failed to play sound: ${soundFileUrl}`, error),
            });
            sound.play();
            return sound;
        };
        // Specify volume at 50% for start and end tones (0.5 = 50%)
        this.startSound = this.initializeSound(config.startSoundFileUrl, 0.5);
        this.endSound = this.initializeSound(config.endSoundFileUrl, 0.5);
    }
}
export default AudioPlayer;
